import { render, staticRenderFns } from "./FeedbackManagerModal.vue?vue&type=template&id=638c1fa6&"
import script from "./FeedbackManagerModal.vue?vue&type=script&lang=js&"
export * from "./FeedbackManagerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports